import { Component, EventEmitter, HostListener, Inject, ViewChild, input, Input, OnInit, Output, PLATFORM_ID, effect, computed, ViewEncapsulation } from '@angular/core';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ClickOutsideDirective, QRCodeService, SlideUpAnimation, CampaignService, TooltipDirective, IFileModel, TitleService, CampaignAccessLevelEnum } from '@sml/utility';
import { IconsComponent } from '@sml/icons';
import { ButtonsModule, ButtonType } from '@sml/buttons';
import { environment as env } from '@env/environment';
import { ActivatedRoute } from '@angular/router';
import { DialogComponent } from '@sml/dialog';
import { SpinnerService } from '@sml/spinner';
import { ICampaignDetailModel, CampaignSignalService, CommunitySignalService, PlatformService } from '@sml/utility';
import { ToastrService } from '@sml/toastr';
import { ChangeDetectorRef } from '@angular/core';
import { DrawerComponent } from '@sml/drawer';

type shareType = 'copy' | 'qr' | 'facebook' | 'linkedin';

@Component({
  selector: 'sml-share-downdown',
  imports: [CommonModule, IconsComponent, ButtonsModule, ClickOutsideDirective, DialogComponent, TooltipDirective
  ],
  templateUrl: './share-downdown.component.html',
  styleUrl: './share-downdown.component.scss',
  animations: [SlideUpAnimation],
  encapsulation: ViewEncapsulation.None
})
export class ShareDowndownComponent implements OnInit {
  @Input() isMapViewEnabled: boolean | null = false;
  @Input() iscalledFromCampaign: boolean = false;
  @Input() isCalledFromAboutPage: boolean = false;
  @Input() isPublic: boolean = true;
  @Input() subject: string = '';
  @Input() communityName: any = ''
  @Input() contentNameBold=false;
  @Input() initiativeStatus: number | null = null;
  public isMobile = false;
  public showShareDropdown = false;
  public campaigndetails: ICampaignDetailModel | null = null;
  campaignUrl = "";
  campaignPrivateUrl="";
  initiativeUrl="";
  isCampaign = true;
  isQr = false;
  isPrivate=false;
  qrCodeImageUrl: string | undefined;
  campaignAccessType = CampaignAccessLevelEnum
  @Input() buttonType: ButtonType = 'secondary';
  @Input() isDropdown: boolean = false;
  @Input() showShareButton = true;
  @Input() contentName = 'Share';
  @Input() shareIconName = 'share';
  @Input() shareButtonClasses = '';
  @Input() identifierPrefix = '';
  @Input() isLoggedIn = true;
  @Input() isTokenExpired = false;
  @Input() isCalledForItem = false;
  @Input() isInitiative = false;
  @Input() initiativeName='';
  isValidCommunityUser = computed(() => this.communitySignalService.signalIsValidCommunityUser());
  communityId = 0;
  campaignId = 0;
  initiativeId = 0;
  sharedUrl = input();
  @Output() emitShare = new EventEmitter<shareType>();
  @Output() drawerOpen = new EventEmitter<boolean>();
  @ViewChild('smlDialog') smlDialog!: DialogComponent;
  shareLink: string = '';
  campaignMapButtonTooltip = "Map view is disabled for this Campaign. Kindly ensure it is enabled before embedding the Map View."
  public campaignMapText: string = 'Allow your community members to explore your campaign through its map. Participants will be able to register/pay online if applicable, but google pay will be disabled for all embedded campaigns.';
  public fullCampaignText: string = 'Allow your community members to explore the campaign directly on your website. Participants will be able to register/pay online if applicable, but google pay will be disabled for all embedded campaigns.';
  public initiativeText : string = 'Allow your community members to explore the community initiative directly on your website.'
  isMapButtonSelected: boolean = false;
  isFullCampaignSelected: boolean = false;
  constructor(
    private readonly qrCodeService: QRCodeService,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly activatedRoute: ActivatedRoute,
    private readonly spinnerService: SpinnerService,
    private readonly toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private readonly titleService: TitleService,
    private readonly campaignSignalService: CampaignSignalService,
    private readonly communitySignalService: CommunitySignalService,
    private readonly platformService: PlatformService,
  ) {

    effect(() => {
      this.campaigndetails = this.campaignSignalService.getCampaignDetail() ?? null;
      //this.campaignUrl = this.decodedUrl();
    });

  }

  ngOnInit(): void {
    this.checkWindowSize();
    this.activatedRoute.params.subscribe(params => {
      this.communityId = params['id'];
      this.campaignId = params['campaignId'];
      this.initiativeId = params['initiativeId'];
      this.campaignUrl = env.webUrl + `/community/${this.communityId}/campaign/${this.campaignId}`
      this.campaignPrivateUrl = `${env.webUrl}/community/${this.communityId}/campaign/${this.campaignId}/overview?private=true`;
      this.initiativeUrl = `${env.webUrl}/community/${this.communityId}/initiative/${this.initiativeId}`;
    });

  }

  openShareDropdown(): void {
    if (this.isCampaign && this.iscalledFromCampaign) {
      document.body.classList.add('share-open');
    }

    this.showShareDropdown = !this.showShareDropdown;
    this.isDropdown = !this.isDropdown;
    // if (this.isMobile && this.showShareDropdown) {
    //   this.document.body.classList.add('tw-overflow-hidden');
    //   const headerElement = this.document.getElementById('header');
    //   if (headerElement) {
    //     headerElement.style.zIndex = '10';
    //   }
    // }
    if (this.iscalledFromCampaign) {
      setTimeout(() => {
        this.smlDialog?.openModal();
      }, 0);
    }
  }
  generateQrCode(): void {
    this.spinnerService.showSpinner();
    const CommunityId = this.activatedRoute.snapshot.params['id'];
    const envurl = env;
    const url = this.isInitiative
      ? envurl.webUrl + '/community/' + CommunityId + '/initiative/' + this.initiativeId
      : envurl.webUrl + '/community/' + CommunityId + '/campaign/' + this.campaignId + '/overview';
    this.qrCodeService.getQRCodeBasedOnUrl(url)
      .subscribe({
        next: (response) => {
          this.qrCodeImageUrl = `data:image/png;base64,${response}`;
          this.spinnerService.hideSpinner();
        },
        error: (err) => {
          this.spinnerService.hideSpinner();
          console.error('Error generating QRCode:', err);
        },
      });
  }
  copyEmbeddedCode(): void {
    if(this.isInitiative){
      navigator.clipboard.writeText(this.initiativeIframeHtml);
    }
    else{
    navigator.clipboard.writeText(this.iFramehtml);
    }
    this.toastr.default({
      message: '',
      title: 'HTML code copied to clipboard.',
      icon: 'copy',
      close: false,
    });

  }

  get initiativeIframeHtml(){
        return `
  <div id="sml-embed-wrapper" style="position:relative;overflow:hidden;height:750px;max-width:1810px;">
  <style>
    #sml-embed-loader {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      z-index: 9999;
      border-radius: 10px;
      border: 1px solid #e0e0e0;
      animation: sml-fade-out 0.5s ease-out 3s forwards;
    }

    #sml-embed-loader .loading-text {
      margin-top: 60px;
      color: var(--Typography-Color-dark, #010F12) !important;
      font-family: Satoshi;
      font-size: 16px !important;
      font-style: normal !important;
      font-weight: 700 !important;
      line-height: 20px !important;
    }

    .dots-circle-spinner {
      height: 16px;
      width: 16px;
      border-radius: 50%;
      box-shadow:
        16px 0 0 0,
        0 16px 0 -6px,
        -16px 0 0 -4px,
        0 -16px 0 -2px;
      animation: dots-circle-rotation 1.5s linear infinite;
      transform: scale(1.7);
      opacity: 1;
      -webkit-animation: 1.5s linear 150ms normal infinite forwards running dots-circle-rotation;
      animation: 1.5s linear 150ms normal infinite forwards running dots-circle-rotation;
    }

    @keyframes dots-circle-rotation {
      100% {
        transform: rotate(360deg);
      }
    }

    @-webkit-keyframes dots-circle-rotation {
      100% {
        box-shadow:
          1em 0em 0 0em #fc9f5b,
          0em 1em 0 -0.375em #106b8e,
          -1em 0em 0 -0.25em #fc9f5b,
          0em -1em 0 -0.125em #106b8e;
      }

      75% {
        box-shadow:
          1em 0em 0 -0.375em #fc9f5b,
          0em 1em 0 -0.25em #106b8e,
          -1em 0em 0 -0.125em #fc9f5b,
          0em -1em 0 0em #106b8e;
      }

      50% {
        box-shadow:
          1em 0em 0 -0.25em #fc9f5b,
          0em 1em 0 -0.125em #106b8e,
          -1em 0em 0 0em #fc9f5b,
          0em -1em 0 -0.375em #106b8e;
      }

      25% {
        box-shadow:
          1em 0em 0 -0.125em #fc9f5b,
          0em 1em 0 0em #106b8e,
          -1em 0em 0 -0.375em #fc9f5b,
          0em -1em 0 -0.25em #106b8e;
      }

      0% {
        box-shadow:
          1em 0em 0 0em #fc9f5b,
          0em 1em 0 -0.375em #106b8e,
          -1em 0em 0 -0.25em #fc9f5b,
          0em -1em 0 -0.125em #106b8e;
      }
    }

    @keyframes dots-circle-rotation {
      100% {
        box-shadow:
          1em 0em 0 0em #fc9f5b,
          0em 1em 0 -0.375em #106b8e,
          -1em 0em 0 -0.25em #fc9f5b,
          0em -1em 0 -0.125em #106b8e;
      }

      75% {
        box-shadow:
          1em 0em 0 -0.375em #fc9f5b,
          0em 1em 0 -0.25em #106b8e,
          -1em 0em 0 -0.125em #fc9f5b,
          0em -1em 0 0em #106b8e;
      }

      50% {
        box-shadow:
          1em 0em 0 -0.25em #fc9f5b,
          0em 1em 0 -0.125em #106b8e,
          -1em 0em 0 0em #fc9f5b,
          0em -1em 0 -0.375em #106b8e;
      }

      25% {
        box-shadow:
          1em 0em 0 -0.125em #fc9f5b,
          0em 1em 0 0em #106b8e,
          -1em 0em 0 -0.375em #fc9f5b,
          0em -1em 0 -0.25em #106b8e;
      }

      0% {
        box-shadow:
          1em 0em 0 0em #fc9f5b,
          0em 1em 0 -0.375em #106b8e,
          -1em 0em 0 -0.25em #fc9f5b,
          0em -1em 0 -0.125em #106b8e;
      }
    }

    #sml-embed-wrapper iframe {
      opacity: 0;
      animation: sml-fade-in 0.5s ease-in 3s forwards;
    }

    @keyframes sml-fade-out {
      to {
        opacity: 0;
        visibility: hidden;
      }
    }

    @keyframes sml-fade-in {
      to {
        opacity: 1;
      }
    }
  </style>

  <div id="sml-embed-loader">
    <div class="dots-circle-spinner"></div>
    <div class="loading-text">Loading Initiative...</div>
  </div>

  <iframe
      title="Your Initiative Powered by SeeMyLegacy"
      style="border-radius:10px;
      border: 1px solid #828485;
      background: var(--White-Main, #FFF);position: absolute; top:0; left:0; bottom:0; right:0; width:99%; height:99%"
      src="${this.initiativeUrl}"
      allowpaymentrequest
      allowtransparency="true"
    ></iframe>
</div>`
  }

  get iFramehtml() {
    return `
  <div id="sml-embed-wrapper" style="position:relative;overflow:hidden;height:750px;max-width:1440px;">
  <style>
    #sml-embed-loader {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      z-index: 9999;
      border-radius: 10px;
      border: 1px solid #e0e0e0;
      animation: sml-fade-out 0.5s ease-out 3s forwards;
    }

    #sml-embed-loader .loading-text {
      margin-top: 60px;
      color: var(--Typography-Color-dark, #010F12) !important;
      font-family: Satoshi;
      font-size: 16px !important;
      font-style: normal !important;
      font-weight: 700 !important;
      line-height: 20px !important;
    }

    .dots-circle-spinner {
      height: 16px;
      width: 16px;
      border-radius: 50%;
      box-shadow:
        16px 0 0 0,
        0 16px 0 -6px,
        -16px 0 0 -4px,
        0 -16px 0 -2px;
      animation: dots-circle-rotation 1.5s linear infinite;
      transform: scale(1.7);
      opacity: 1;
      -webkit-animation: 1.5s linear 150ms normal infinite forwards running dots-circle-rotation;
      animation: 1.5s linear 150ms normal infinite forwards running dots-circle-rotation;
    }

    @keyframes dots-circle-rotation {
      100% {
        transform: rotate(360deg);
      }
    }

    @-webkit-keyframes dots-circle-rotation {
      100% {
        box-shadow:
          1em 0em 0 0em #fc9f5b,
          0em 1em 0 -0.375em #106b8e,
          -1em 0em 0 -0.25em #fc9f5b,
          0em -1em 0 -0.125em #106b8e;
      }

      75% {
        box-shadow:
          1em 0em 0 -0.375em #fc9f5b,
          0em 1em 0 -0.25em #106b8e,
          -1em 0em 0 -0.125em #fc9f5b,
          0em -1em 0 0em #106b8e;
      }

      50% {
        box-shadow:
          1em 0em 0 -0.25em #fc9f5b,
          0em 1em 0 -0.125em #106b8e,
          -1em 0em 0 0em #fc9f5b,
          0em -1em 0 -0.375em #106b8e;
      }

      25% {
        box-shadow:
          1em 0em 0 -0.125em #fc9f5b,
          0em 1em 0 0em #106b8e,
          -1em 0em 0 -0.375em #fc9f5b,
          0em -1em 0 -0.25em #106b8e;
      }

      0% {
        box-shadow:
          1em 0em 0 0em #fc9f5b,
          0em 1em 0 -0.375em #106b8e,
          -1em 0em 0 -0.25em #fc9f5b,
          0em -1em 0 -0.125em #106b8e;
      }
    }

    @keyframes dots-circle-rotation {
      100% {
        box-shadow:
          1em 0em 0 0em #fc9f5b,
          0em 1em 0 -0.375em #106b8e,
          -1em 0em 0 -0.25em #fc9f5b,
          0em -1em 0 -0.125em #106b8e;
      }

      75% {
        box-shadow:
          1em 0em 0 -0.375em #fc9f5b,
          0em 1em 0 -0.25em #106b8e,
          -1em 0em 0 -0.125em #fc9f5b,
          0em -1em 0 0em #106b8e;
      }

      50% {
        box-shadow:
          1em 0em 0 -0.25em #fc9f5b,
          0em 1em 0 -0.125em #106b8e,
          -1em 0em 0 0em #fc9f5b,
          0em -1em 0 -0.375em #106b8e;
      }

      25% {
        box-shadow:
          1em 0em 0 -0.125em #fc9f5b,
          0em 1em 0 0em #106b8e,
          -1em 0em 0 -0.375em #fc9f5b,
          0em -1em 0 -0.25em #106b8e;
      }

      0% {
        box-shadow:
          1em 0em 0 0em #fc9f5b,
          0em 1em 0 -0.375em #106b8e,
          -1em 0em 0 -0.25em #fc9f5b,
          0em -1em 0 -0.125em #106b8e;
      }
    }

    #sml-embed-wrapper iframe {
      opacity: 0;
      animation: sml-fade-in 0.5s ease-in 3s forwards;
    }

    @keyframes sml-fade-out {
      to {
        opacity: 0;
        visibility: hidden;
      }
    }

    @keyframes sml-fade-in {
      to {
        opacity: 1;
      }
    }
  </style>

  <div id="sml-embed-loader">
    <div class="dots-circle-spinner"></div>
    <div class="loading-text">Loading Campaign...</div>
  </div>

  <iframe
      title="Your Campaign Powered by SeeMyLegacy"
      style="border-radius:10px;
      border: 1px solid #828485;
      background: var(--White-Main, #FFF);position: absolute; top:0; left:0; bottom:0; right:0; width:99%; height:99%"
      src="${this.campaignUrl}${this.isMapButtonSelected ? '/map' : ''}"
      allowpaymentrequest
      allowtransparency="true"
    ></iframe>
</div>`
  };

  copyImage() {
    if (!this.qrCodeImageUrl) {
      console.error("No QR Code available to copy.");
      return;
    }
    fetch(this.qrCodeImageUrl)
      .then(res => res.blob())
      .then(blob => {
        const clipboardItem = new ClipboardItem({ "image/png": blob });
        navigator.clipboard.write([clipboardItem])
          .then(() => {
            this.toastr.default({
              message: '',
              title: `${this.isInitiative ? 'Initiative' : 'Campaign'} QR copied`,
              icon: 'copy',
              close: false,
            })
          })
          .catch(err => {
            console.error("Failed to copy QR Code:", err);
          });
      });
  }
  decodedUrl = computed(() => {
    const raw = this.sharedUrl(); // signal value
    return raw ? decodeURIComponent(raw as string) : '';
  });

  downloadImage() {
    if (this.qrCodeImageUrl) {
      const a = document.createElement('a');
      a.href = this.qrCodeImageUrl;
      a.download = this.campaigndetails?.campaignDisplayName || this.initiativeName + '-QR';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }

  handleCopyUrl(): void {
    // navigator.clipboard.writeText(
    //   `${env.webUrl}/community/1008/campaign/${this.campaigndetails?.id}/overview`
    // );
    const url = this.isInitiative ? this.initiativeUrl : this.campaignUrl;
    navigator.clipboard.writeText(url);
    this.toastr.default({
      message: '',
      title: `${this.isInitiative ? 'Initiative' : 'Campaign'} link copied to clipboard.`,
      icon: 'copy',
      close: false,
    });
  }
  handleCopyPrivateUrl(): void {
    // navigator.clipboard.writeText(
    //   `${env.webUrl}/community/1008/campaign/${this.campaigndetails?.id}/overview`
    // );
    navigator.clipboard.writeText(this.campaignPrivateUrl);
    this.toastr.default({
      message: '',
      title: `${this.isInitiative ? 'Initiative' : 'Campaign'} Private Share Link copied to clipboard.`,
      icon: 'copy',
      close: false,
    });
  }

  closeShareDropdown(): void {
    document.body.classList.remove('share-open');
    this.showShareDropdown = false;
    this.isQr = false;
    this.isCampaign = true;
    if (this.iscalledFromCampaign && this.smlDialog) {
      setTimeout(() => {
        this.smlDialog.closeModal();
      }, 0);
    }
  }

  onFullCampaignClick() {
    this.isFullCampaignSelected = true;
    this.isMapButtonSelected = false;
  }

  onMapClick() {
    this.isMapButtonSelected = true;
    this.isFullCampaignSelected = false;
  }

  async showQrCode() {
    this.isQr = true;
    await this.generateQrCode();
    this.isCampaign = false;
  }

  showCampaign(): void {
    this.isCampaign = true;
    this.isQr = false;
    this.isPrivate=false;
  }
  showselectedCampaign(): void {
    this.isCampaign = false;
    this.isQr = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.checkWindowSize();
  }


  checkWindowSize(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 768;
    }
  }

  openDrawer() {
    this.drawerOpen.emit(true);
    this.closeShareDropdown();
  }

  handleShare(type: shareType): void {
    this.emitShare.emit(type);
    this.closeShareDropdown();
  }

  OpenFacebook() {
    if (isPlatformBrowser(this.platformId)) {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.sharedUrl()}`, '_blank');
    }
    // this.closeShareDropdown();
  }


  OpenLinkedin() {
    if (isPlatformBrowser(this.platformId)) {
      window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${this.sharedUrl()}`, '_blank');
    }
  }

  OpenTwitter() {
    const url = this.sharedUrl();
    if (isPlatformBrowser(this.platformId)) {
      window.open(
        `https://twitter.com/intent/tweet?url=${url}`,
        '_blank'
      );
    }
  }

  OpenMailto() {
  const message = this.isCalledFromAboutPage
    ? `Explore ${this.communityName} and see how you can get involved. - ${this.sharedUrl()}`
    : `Find out how to get involved. - ${this.sharedUrl()}`;
  const body = message;
  const subject = this.subject || '';
  if (isPlatformBrowser(this.platformId)) {
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  }
}
showPrivateLink(){
  this.isPrivate=true;
  this.isQr=false;
  this.isCampaign=false;
}

calculateDynamicPaddingBottom() {
  if (isPlatformBrowser(this.platformId) && this.isMobile) {
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    const headerHeight = 376; // Dialog header height
    const infoBoxHeight = 120; // Info box (Private Share Link section)
    const inputBoxHeight = 100; // Input and button box
    const gapSpacing = 40; // Gaps between elements
    
    const usedHeight = headerHeight + infoBoxHeight + inputBoxHeight + gapSpacing;
    const remainingHeight = viewportHeight - usedHeight;
    
    return `${remainingHeight}px`;
  }
  return '140px'; // Default fallback
}
}
